<template>
  <div class="form bid_form">

    <v-modal-contents ref="modal_contents_agree">
      <template v-slot:title>

        <div class="terms_of_use__title mt-30 pl-3 ">
          <div class="h2_title">Пользовательское соглашение!</div>

        </div>

      </template>
      <template v-slot:content>
        <div class="terms_of_use mt-30 ">
          <p class="red">ТЕКСТ НАХОДИТСЯ В РАЗРАБОТКЕ</p>

          <div class="mt-30">
            <button class="px-30 btn_bordered "
                    @click="$refs.modal_contents_agree.modal_open()">
              Прочитал
            </button>

          </div>
        </div>
      </template>
    </v-modal-contents>
    <v-modal-contents ref="modal_contents_successfully" class="modal_contents_successfully">
      <template v-slot:title>

        <div class="terms_of_use__title mt-30 pl-3 ">
          <div class="h2_title">Заказать образцы!</div>

        </div>

      </template>
      <template v-slot:content>
        <div class="terms_of_use mt-30 ">
          <p class="green_messs">Сообщение отправлено!</p>

        </div>
      </template>
    </v-modal-contents>

    <div class="nr_container_content">
      <div class="form__inner">
        <h2 class="form__title">
          Заказать образцы
        </h2>
        <slot name="sm-title"></slot>

        <v-form class="form__content" ref="form_inner"
                v-model="valid"
        >
          <div class="form__box">
            <v-text-field class="form__input"
                          v-model="name"
                          :rules="nameRules"

            >
              <template v-slot:label>
                Ваше имя *
              </template>
            </v-text-field>
            <v-text-field class="form__input"
                          v-model="company"

            >
              <template v-slot:label>
                Название вашей компании
              </template>
            </v-text-field>
            <v-text-field class="form__input"
                          v-model="city"
                          :rules="cityRules"

            >
              <template v-slot:label>
                Ваш город *
              </template>
            </v-text-field>
          </div>
          <div class="form__box">
            <v-text-field class="form__input"
                          v-model="tel"
                          :rules="tel_Rules"
            >
              <template v-slot:label>
                Ваш телефон
              </template>
            </v-text-field>
            <v-text-field class="form__input"
                          v-model="mail"
                          :rules="mailRules"

            >
              <template v-slot:label>
                Ваш e-mail *
              </template>
            </v-text-field>

          </div>
          <div class="form__box">
            <v-textarea class="form__input"
                        v-model="message"
                        rows="2"
                        no-resize
            >
              <template v-slot:label>
                Ваше обращение
              </template>
            </v-textarea>
          </div>
          <div class="form__box">
            <div class="form__box_info mt-2">
              *Укажите ваши пожелания: размер шпули, количество бобин образцов, толщина нити, цвет нити, вес в кг нити
            </div>
        <span class="form__policy mt-3">
          Нажимая кнопку отправить, вы соглашаетесь с нашей
          <a href="#" @click="$refs.modal_contents_agree.modal_open('scroll_false')" class="form__link">
            политикой обработки данных
          </a>
        </span>
            <button class="form__button"
                    :disabled="!valid"
                    @click.prevent="send_form"
            >
              Отправить
            </button>
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import VModalContents from "./modal_contents";

export default {
  name: "orderSamples",
  props: {
    // categories: Array | String | Number | Boolean | Object,
    show: String | Number | Boolean,
  },
  components: {
    VModalContents: VModalContents,
  },
  data() {
    return {
      valid: false,
      name: '',
      nameRules: [
        (v) => !!v || "Поле 'Имя' не может быть пустым",
        (v) => (v && v.length >= 3) || "Поле 'Имя' не можети быть меньше 3 символов",
      ],
      company: '',
      city: '',
      cityRules: [
        (v) => !!v || "Поле 'Город' не может быть пустым",
        (v) => (v && v.length >= 3) || "Поле 'Город' не можети быть меньше 3 символов",
      ],
      tel: '',
      tel_Rules: [
        // (v) => /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(v) || "Телефон заполнен неправильно",
      ],
      mail: '',
      mailRules: [
        (v) => !!v || "E-mail обязателен",
        (v) => /.+@.+\..+/.test(v) || "E-mail заполнен неправильно",
      ],
      message: '',

      cat_itemsRules: [
        (v) => (v && v.length != 0) || "Поле 'Категория' не может быть пустым",
      ],
      /*cat_items: [
        {
          sel_id: 1,
          name: "Категория 1",
        },
        {
          sel_id: 2,
          name: "Категория 2",
        },
        {
          sel_id: 3,
          name: "Категория 2",
        },
      ],*/
      // cat_items: this.categories,
      // defaultСatSelected: {
      //   sel_id: 0,
      // },
    }
  },
  methods: {
    send_form() {

      let url = "/ajax/send_bid_form.php";
      let params = new URLSearchParams();
      // let category = this.cat_items.find(cat_items => cat_items.sel_id === this.defaultСatSelected.sel_id).name;
      // console.log(category);
      params.set("name", this.name);
      params.set("company", this.company);
      params.set("city", this.city);
      params.set("tel", this.tel);
      params.set("mail", this.mail);
      params.set("message", this.message);
      // params.set("category", category);
      params.set("ajaxPost", "Y");
      params.set("url", document.location.href);

      var result = fetch(url, {method: "POST", body: params})
          .then(function (responce) {
            return responce.json();
          })
          .then((data) => {
            console.log(JSON.stringify(data));
          });
      console.log(result);
      this.$refs.form_inner.reset();
      this.$refs.modal_contents_successfully.modal_open() //- вывод сообщения
    }
  }
}
</script>
<style lang="scss">
.form__box_info {
  color: rgb(101, 101, 101);
  font-family: "MuseoSansCyrl-500";
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0%;
  text-align: left;
}
</style>
<style scoped lang="scss">
.form {
  width: 100%;

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 40px;
  }

  &__title {
    font-weight: 600;
    font-size: 28px;
    line-height: 100%;
    color: #282828;

    @media(max-width: 450px) {
      font-size: 22px;
    }
  }

  &__content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 20px;
    box-shadow: 0px 4px 30px 4px rgb(0 0 0 / 5%);
    border-radius: 20px;
    padding: 25px;
  }

  &__box {
    width: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 20px;
    justify-content: end;
    @media (max-width: 768px) {
      flex-wrap: wrap;
    }
  }

  &__input {
    width: auto;
    border: 1px solid #E2E2E2;
    border-radius: 10px;
    padding: 20px 15px !important;
    margin: 0 !important;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    color: #282828;
    resize: none;
  }

  .error--text {
    border: 1px solid #F55640;
  }

  &__policy {
    max-width: 379px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    color: #656565;
  }

  &__link {
    display: inline-block;
    color: #F55640;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &__button {
    background-color: #F65F4A;
    border-radius: 48px;
    color: #FFFFFF;
    padding: 14px 0;
    max-width: 300px;
    width: 100%;
    transition: all .3s ease;

    &:disabled {
      background: #E2E2E2;
      color: #656565;

      &:hover {
        background: #E2E2E2;
        color: #656565;
      }
    }

    &:hover {
      background-color: #F55640;
    }
  }
}

</style>